import React from 'react';
import { motion } from 'framer-motion';
import { PriceDisplay } from './PriceDisplay';
export function BonusSection() {
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/jGFQcmqQqkdGmPhgxZNer5/552d0bc3-2360-478d-8405-4e0654fe3562.png',
    number: 'BONUS 1',
    title: 'Qué comer en cada fase de tu ciclo',
    description: <>
          Para evitar:{' '}
          <span className="font-bold" data-id="element-12">
            antojos, inflamación, cambios de energía
          </span>
          . Entendés y acompañas a tu cuerpo.
        </>,
    price: 9990
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/sjo2vbf9WcpSX196xWZ1Eb/f8c40fa4-3558-4f3b-bbe8-c5b198c3b661.png',
    number: 'BONUS 2',
    title: '10 postres sin azúcar que no parecen saludables',
    description: <>
          Seguís disfrutando…{' '}
          <span className="font-bold bg-yellow-200/60 px-1 rounded" data-id="element-13">
            sin culpa
          </span>
          .
        </>,
    price: 9990
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/iqenXXN8SYg3erWJXbBZJs/Captura_de_pantalla_2026-04-11_a_la(s)_10.12.47_a._m..png',
    number: 'BONUS 3',
    title: 'Comidas Proteicas que quitan el hambre por horas',
    description: <>
          Para: evitar picar todo el día,{' '}
          <span className="font-bold" data-id="element-14">controlar la ansiedad</span>, sentirte{' '}
          <span className="bg-yellow-200/60 px-1 rounded font-bold" data-id="element-15">
            saciada de verdad
          </span>
          .
        </>,
    price: 8900
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/i758vm3qytwwCtE7o8PsX8/318dca2b-6b9f-4f00-b545-8cd085b3f623.png',
    number: 'BONUS 4',
    title: 'Cómo resolver TODAS tus comidas en 2 horas',
    description: <>
          Cocinás una vez… y{' '}
          <span className="font-bold bg-yellow-200/60 px-1 rounded" data-id="element-16">
            comés bien toda la semana
          </span>
          .
        </>,
    price: 8900
  }];
  return <section className="py-16 md:py-24 px-4 bg-[#FFFDF8]" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-20">
            Con tu compra hoy te llevás estos <br className="hidden md:block" data-id="element-21" />
            <span className="text-bonus" data-id="element-22">4 BONUS EXCLUSIVOS DE REGALO ✨</span>
          </h2>
        </motion.div>

        <div className="space-y-6 mb-12" data-id="element-23">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white border-2 border-bonus/30 rounded-2xl p-6 md:p-8 shadow-lg relative overflow-hidden" data-id="element-24">
              <div className="absolute top-0 right-0 bg-bonus text-white px-4 py-1 rounded-bl-xl font-bold text-sm" data-id="element-25">
                REGALO
              </div>
              <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-26">
                <div className="w-56 h-56 md:w-64 md:h-64 rounded-xl overflow-hidden flex-shrink-0 shadow-md" data-id="element-27">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-28" />
                </div>
                <div className="flex-grow" data-id="element-29">
                  <div className="text-bonus font-bold text-sm mb-1 tracking-wider" data-id="element-30">
                    {bonus.number}
                  </div>
                  <h3 className="text-2xl font-bold text-charcoal mb-3" data-id="element-31">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-700 mb-4 text-lg" data-id="element-32">
                    {bonus.description}
                  </p>
                  <div className="inline-block bg-gray-50 px-4 py-2 rounded-lg border border-gray-100" data-id="element-33">
                    <span className="text-gray-500 font-medium mr-2" data-id="element-34">
                      Precio:
                    </span>
                    <PriceDisplay basePriceArs={bonus.price} isCrossedOut className="text-gray-400 mr-2" data-id="element-35" />
                    <span className="text-solution font-bold" data-id="element-36">
                      Hoy → Gratis
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-charcoal text-white rounded-2xl p-8 text-center shadow-2xl" data-id="element-37">
          <h3 className="text-2xl font-bold mb-4" data-id="element-38">Valor Total de los Bonus</h3>
          <div className="flex justify-center items-center space-x-4 text-3xl md:text-4xl font-bold" data-id="element-39">
            <PriceDisplay basePriceArs={37780} isCrossedOut className="text-gray-400" data-id="element-40" />
            <span className="text-bonus" data-id="element-41">¡GRATIS HOY!</span>
          </div>
        </motion.div>
      </div>
    </section>;
}